<template>
  <vs-popup
    :active="isEditingCalculated"
    title="Edit Category"
    v-on:update:active="isEditingUpdated"
  >
    <div>
      Title:<br />
      <vs-input class="w-full" v-model="CategoryTitle" /><br />
      Description:<br />
      <quillEditor
        style="min-height: 400px; max-height: 400px"
        v-model="CategoryDescription"
      ></quillEditor>
    </div>
    <vs-button color="primary" type="filled" @click="save" class="mb-3"
      >Save</vs-button
    >
  </vs-popup>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import SkillsService from "@/skills/skillsService.js";

export default {
  data() {
    return {
      category: null,
      isEditingPrivate: false,
      CategoryTitle: "",
      CategoryDescription: "",
      CategoryOrder: -1,
      categoryObject: null,
      parentCategoryInternal: null,
    };
  },
  mounted() {
    this.isEditingPrivate = this.isEditing;
  },
  methods: {
    isEditingUpdated(val) {
      this.$emit("updated", val);
    },
    save() {
      var vue = this;
      SkillsService.saveCategory({
        DirectMapping: {
          Id: this.editCategoryId,
          CategoryTitle: this.CategoryTitle,
          CategoryOrder: this.CategoryOrder,
          CategoryDescription: this.CategoryDescription,
        },
        Relations: {
          ParentId: this.parentCategoryInternal.data.FullData.Id,
        },
      }).then(function (response) {
        response.data.Type = "Category";
        response.data.FullData = response.data;

        if (vue.editCategoryId < 1) {
          vue.parentCategoryInternal.append({
            text: response.data.CategoryTitle,
            id: response.data.FullData.Id,
            data: response.data,
          });
        }

        vue.$vs.notify({
          title: "Success",
          text:
            "Category " +
            response.data.CategoryTitle +
            " was saved successfully.",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        var updatedObj = {
          isVisible: false,
          updatedObj: response.data,
        };

        vue.$emit("updated", updatedObj);
      });
    },
  },
  props: ["isEditing", "editCategoryId", "parentCategoryNode"],
  components: {
    quillEditor,
  },
  computed: {
    isEditingCalculated: function () {
      return this.isEditing && this.isEditing.isEdit
        ? this.isEditing.isEdit
        : false;
    },
  },
  watch: {
    isEditing: function (newEditing, oldEditing) {},
    editCategoryId: function (newId, oldId) {
      var instance = this;
      if (newId === -1) {
        instance.Id = -1;
        instance.CategoryTitle = "";
        instance.CategoryDescription = "";
        instance.CategoryOrder = -1;
      } else {
        SkillsService.getCategory(newId).then(function (response) {
          instance.CategoryTitle = response.data.CategoryTitle;
          instance.CategoryDescription = response.data.CategoryDescription;
          instance.CategoryOrder = response.data.CategoryOrder;
        });
      }
    },
    parentCategoryNode(newVal, oldVal) {
      this.parentCategoryInternal = newVal;
    },
  },
};
</script>